// extracted by mini-css-extract-plugin
export default {"kitchenLabel":"pickleballCourt_kitchenLabel__Njxx4"};